import { request } from "../../utils/config"

export const CREATE_DELIVERY = async (data) => {
  const response = await request({ url: `Deliveries`, method: "POST", data })
  return response.data
}

export const UPDATE_DELIVERY = async (data) => {
  const response = await request({ url: `Deliveries`, method: "PUT", data })
  return response.data
}

export const DELETE_DELIVERY = async (data) => {
  const response = await request({ url: `Deliveries/BulkDelete`, method: "DELETE", data })
  return response.data
}

export const CONFIRM_DELIVERY = async (id: number) => {
  const response = await request({ url: `Deliveries/Confirm/${id}`, method: "PUT" })
  return response.data
}

// 3-bosqich TZ: "Jo'natildi" bosqichi (yo'lga chiqdi)
export const SHIP_DELIVERY = async (id: number) => {
  const response = await request({ url: `Deliveries/Ship/${id}`, method: "PUT" })
  return response.data
}
// talabnoma §9.1 (2026-09-06): logistika tasdig'i (haydovchi ism+telefon shart) — shundan keyingina «Отправить»
export const CONFIRM_LOGISTICS = async (id: number) => {
  const response = await request({ url: `Deliveries/ConfirmLogistics/${id}`, method: "PUT" })
  return response.data
}

// tog'a #342 / katalog #6024: ilovasiz haydovchi havolasi (/driver/<token>) — token serverda imzolanadi
export const DRIVER_LINK = async (id: number): Promise<{ token: string }> => {
  const response = await request({ url: `Deliveries/${id}/DriverLink`, method: "GET" })
  return response.data
}

// Farhod #478: qabul qiluvchi rad etadi (sabab bilan)
export const REJECT_DELIVERY = async (id: number, reason?: string) => {
  const response = await request({ url: `Deliveries/Reject/${id}`, method: "PUT", data: { reason: reason || "" } })
  return response.data
}
